import cx from 'classnames'
import { FormEvent, ReactNode } from 'react'

import Button from '@components/buttons/button'

interface AlertProps {
  buttonText?: string
  error?: boolean
  success?: boolean
  onClick?: (event: FormEvent) => void
  children: ReactNode
  className?: string
}

const Alert = ({
  buttonText,
  error,
  success,
  onClick,
  children,
  className,
}: AlertProps) => {
  return (
    <div
      className={cx(
        'flex flex-col gap-y-4 p-5 rounded-md border border-1 font-medium text-center',
        {
          'text-current border-current': !error && !success,
          'text-success border-success': !error && success,
          'text-error border-error': error,
        },
        className,
      )}
    >
      <span>{children}</span>

      {!!buttonText && !!onClick && (
        <Button variant="secondary" size="small" onClick={onClick}>
          {buttonText}
        </Button>
      )}
    </div>
  )
}

export default Alert
